// extracted by mini-css-extract-plugin
export default {"bookingdetails":"Details_bookingdetails__gs0bh"};